export default {
  FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_ERROR: 'FETCH_QUESTIONS_ERROR',
  FETCH_SITE_REQUEST: 'FETCH_SITE_REQUEST',
  FETCH_SITE_SUCCESS: 'FETCH_SITE_SUCCESS',
  FETCH_SITE_ERROR: 'FETCH_SITE_ERROR',
  FETCH_SITE_NOT_FOUND: 'FETCH_SITE_NOT_FOUND',
  POST_JOB_SUCCESS: 'POST_JOB_SUCCESS',
  JOB_CONNECT_MORE_REQUEST: 'JOB_CONNECT_MORE_REQUEST',
  JOB_CONNECT_MORE_SUCCESS: 'JOB_CONNECT_MORE_SUCCESS',
  JOB_CONNECT_MORE_ERROR: 'JOB_CONNECT_MORE_ERROR',
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_LOGIN_ERROR: 'USER_LOGIN_ERROR',
  USER_LOGIN_CHECK_SUCCESS: 'USER_LOGIN_CHECK_SUCCESS',
  USER_LOGIN_CHECK_UNKNOWN: 'USER_LOGIN_CHECK_UNKNOWN',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERROR: 'SET_PASSWORD_ERROR',
  FACEBOOK_CONNECT_SUCCESS: 'FACEBOOK_CONNECT_SUCCESS',
  USER_SET_JWT: 'USER_SET_JWT',
  FETCH_JOB_REQUEST: 'FETCH_JOB_REQUEST',
  FETCH_JOB_ERROR: 'FETCH_JOB_ERROR',
  FETCH_JOB_SUCCESS: 'FETCH_JOB_SUCCESS',
  FETCH_JOB_NOT_FOUND: 'FETCH_JOB_NOT_FOUND',
  FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
  FETCH_CATEGORY_ERROR: 'FETCH_CATEGORY_ERROR',
  FETCH_CATEGORY_SUGGESTIONS_SUCCESS: 'FETCH_CATEGORY_SUGGESTIONS_SUCCESS',
  FETCH_CATEGORY_SUGGESTIONS_ERROR: 'FETCH_CATEGORY_SUGGESTIONS_ERROR',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_ERROR: 'FETCH_CATEGORIES_ERROR',
  FETCH_LOCATION_SUCCESS: 'FETCH_LOCATION_SUCCESS',
  FETCH_LOCATION_ERROR: 'FETCH_LOCATION_ERROR',
  MODAL_HIPROJECTS_STATUS: 'MODAL_HIPROJECTS_STATUS',
  MODAL_CLOSEJOB_STATUS: 'MODAL_CLOSEJOB_STATUS',
  MODAL_JOBDETAILS_STATUS: 'MODAL_JOBDETAILS_STATUS',
  UPDATE_MODAL_ACCOUNT: 'UPDATE_MODAL_ACCOUNT',
  UPDATE_MODAL_FEEDBACK_MESSAGE: 'UPDATE_MODAL_FEEDBACK_MESSAGE',
  UPDATE_MODAL_FEEDBACK_QUOTE: 'UPDATE_MODAL_FEEDBACK_QUOTE',
  UPDATE_MODAL_FEEDBACK_REVIEW: 'UPDATE_MODAL_FEEDBACK_REVIEW',
  HARD_REDIRECT_TO: 'HARD_REDIRECT_TO',
  CLOSE_JOB_SUCCESS: 'CLOSE_JOB_SUCCESS',
  FETCH_JOB_INVITATIONS_REQUEST: 'FETCH_JOB_INVITATIONS_REQUEST',
  FETCH_JOB_INVITATIONS_SUCCESS: 'FETCH_JOB_INVITATIONS_SUCCESS',
  FETCH_JOB_INVITATIONS_ERROR: 'FETCH_JOB_INVITATIONS_ERROR',
  FETCH_JOB_CONNECTIONS_REQUEST: 'FETCH_JOB_CONNECTIONS_REQUEST',
  FETCH_JOB_CONNECTIONS_SUCCESS: 'FETCH_JOB_CONNECTIONS_SUCCESS',
  FETCH_JOB_CONNECTIONS_ERROR: 'FETCH_JOB_CONNECTIONS_ERROR',
  FETCH_JOB_STATUS_SUCCESS: 'FETCH_JOB_STATUS_SUCCESS',
  FETCH_JOB_STATUS_ERROR: 'FETCH_JOB_STATUS_ERROR',
  MARK_CHECKPOINT: 'MARK_CHECKPOINT',
  UNMARK_CHECKPOINT: 'UNMARK_CHECKPOINT',
  SET_IS_FIRST_VIEW: 'SET_IS_FIRST_VIEW',
  FETCH_RECOMMENDATIONS_SUCCESS: 'FETCH_RECOMMENDATIONS_SUCCESS',
  FETCH_RECOMMENDATIONS_ERROR: 'FETCH_RECOMMENDATIONS_ERROR',
  CONNECTION_ADD_WAITLIST_REQUEST: 'CONNECTION_ADD_WAITLIST_REQUEST',
  CONNECTION_ADD_WAITLIST_SUCCESS: 'CONNECTION_ADD_WAITLIST_SUCCESS',
  CONNECTION_ADD_WAITLIST_ERROR: 'CONNECTION_ADD_WAITLIST_ERROR',
  UPDATE_CONNECTION: 'UPDATE_CONNECTION',
  FETCH_QUESTIONS_NOT_FOUND: 'FETCH_QUESTIONS_NOT_FOUND',
  FETCH_THREAD_REQUEST: 'FETCH_THREAD_REQUEST',
  FETCH_THREAD_SUCCESS: 'FETCH_THREAD_SUCCESS',
  FETCH_THREAD_ERROR: 'FETCH_THREAD_ERROR',
  FETCH_CONTACTS_REQUEST: 'FETCH_CONTACTS_REQUEST',
  FETCH_CONTACTS_SUCCESS: 'FETCH_CONTACTS_SUCCESS',
  FETCH_CONTACTS_ERROR: 'FETCH_CONTACTS_ERROR',
  FETCH_FEEDBACK_REQUEST: 'FETCH_FEEDBACK_REQUEST',
  FETCH_FEEDBACK_SUCCESS: 'FETCH_FEEDBACK_SUCCESS',
  FETCH_FEEDBACK_ERROR: 'FETCH_FEEDBACK_ERROR',
  UPDATE_FEEDBACK_ANSWER: 'UPDATE_FEEDBACK_ANSWER',
  REMOVE_FEEDBACK_ANSWER: 'REMOVE_FEEDBACK_ANSWER',
  FETCH_VOUCHER_ACTIVATE_SUCCESS: 'FETCH_VOUCHER_ACTIVATE_SUCCESS',
  CHECK_ACTIVATE_ERROR: 'CHECK_ACTIVATE_ERROR',
  UPDATE_THREAD: 'UPDATE_THREAD',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  FETCH_VOUCHER_SUCCESS: 'FETCH_VOUCHER_SUCCESS',

  ADD_VOUCHER_COUPON_REQUEST: 'ADD_VOUCHER_COUPON_REQUEST',
  ADD_VOUCHER_COUPON_SUCCESS: 'ADD_VOUCHER_COUPON_SUCCESS',
  ADD_VOUCHER_COUPON_DONE: 'ADD_VOUCHER_COUPON_DONE',
  ADD_VOUCHER_COUPON_ERROR: 'ADD_VOUCHER_COUPON_ERROR',

  SHAREABLE_CODE_INPUT: 'SHAREABLE_CODE_INPUT',
  SHAREABLE_QUERY: 'SHAREABLE_QUERY',
  SHAREABLE_CODE_INCORRECT: 'SHAREABLE_CODE_INCORRECT'
};
